import { Usuario, Rol, Empresa, PermisoEmpresa, RolEmpresa } from '../../../core/models';
/**
 * Clase que parsea el userInfo devuelto por el IDP. No es más que eso.
 * Todavía no está completamente diagramada.
 */
export class User {
	private usuario: Usuario;
	roles: Rol[];
	empresas: Empresa[];
	permisos: string[];
	permisosEmpresa: PermisoEmpresa[];
	rolesEmpresa: RolEmpresa[];

	constructor(protected userInfo: any) {
		if (userInfo) {
			this.roles = [];
			if (userInfo.roles) {
				for (let i = 0; i < userInfo.roles.length; i++) {
					this.roles.push(new Rol(userInfo.roles[i]));
				}
			}
			this.permisosEmpresa = [];
			if (userInfo.permisosEmpresa) {
				for (let i = 0; i < userInfo.permisosEmpresa.length; i++) {
					this.permisosEmpresa.push(new PermisoEmpresa(userInfo.permisosEmpresa[i]));
				}
			}
			this.permisos = userInfo.permisos;
			this.empresas = [];
			if (userInfo.empresas) {
				for (let i = 0; i < userInfo.empresas.length; i++) {
					this.empresas.push(new Empresa(userInfo.empresas[i]));
				}
			}
			this.rolesEmpresa = [];
			if (userInfo.rolesEmpresa) {
				for (let i = 0; i < userInfo.rolesEmpresa.length; i++) {
					this.rolesEmpresa.push(new RolEmpresa(userInfo.rolesEmpresa[i]));
				}
			}
		}
	}

	getIdentifier() {
		if (this.userInfo) {
			const doc: string = ['cuit', 'cuil', 'dni', 'pasaporte'].find(
				d => d in this.userInfo && this.userInfo[d].length > 0
			);

			if (doc) {
				return this.userInfo[doc];
			}
		}

		return null;
	}

	/**
	 * Determina si el usuario tiene al menos uno de los roles enviados por parámetro
	 * @param rolList lista de roles a verificar
	 */
	hasAnyRol(rolList: string[]) {
		if (this.roles && rolList) {
			for (let i = 0; i < rolList.length; i++) {
				if (this.roles.find(r => r.nombre === rolList[i])) {
					return true;
				}
			}
		}

		return false;
	}

	/**
	 * Determina si el usuario tiene todos los roles enviados por parámetro
	 * @param rolList lista de roles a verificar
	 */
	hasRoles(rolList: string[] = []) {
		if (this.roles) {
			for (let i = 0; i < rolList.length; i++) {
				if (this.roles.find(r => r.nombre === rolList[i])) {
					return true;
				}
			}
		}
		return false;
	}

	/**
	 * Determina si el usuario tiene todos los permisos enviados por parámetro por empresa
	 * @param permisoList lista de permisos a verificar
	 */
	hasPermisosEmpresa(permisoList: string[]) {
		if (this.permisosEmpresa && permisoList) {
			for (let i = 0; i < permisoList.length; i++) {
				if (!this.permisosEmpresa.find(p => p.permiso === permisoList[i])) {
					return false;
				}
			}
		}

		return true;
	}

	/**
	 * determina si dicha empresa tiene dicho rol
	 * @param empresaId
	 * @param rolEmpresa
	 * @returns boolean
	 */
	hasRolEmpresa(empresaId: any, rolEmpresa: string) {
		return this.rolesEmpresa.find(rE => rE.nombre === rolEmpresa && rE.empresaId === parseInt(empresaId));
	}

	getId() {
		if (this.userInfo && 'id' in this.userInfo) {
			return this.userInfo.id;
		}
	}

	getUsername() {
		if (this.userInfo && 'username' in this.userInfo) {
			return this.userInfo.username;
		}
	}

	getDisplayName() {
		if (this.userInfo && 'username' in this.userInfo) {
			return this.userInfo.username;
		} else if (this.userInfo && 'given_name' in this.userInfo) {
			return this.userInfo.given_name;
		}
		return null;
	}

	getPictureUrl() {
		if (this.userInfo && 'picture' in this.userInfo) {
			return this.userInfo.picture;
		}
		return null;
	}

	getFamilyName() {
		if (this.userInfo && 'family_name' in this.userInfo) {
			return this.userInfo.family_name;
		}
		return null;
	}

	getGivenName() {
		if (this.userInfo && 'given_name' in this.userInfo) {
			return this.userInfo.given_name;
		}
		return null;
	}

	getUsuario() {
		return this.usuario;
	}

	setUsuario(usuario: Usuario) {
		this.usuario = usuario;

		return this;
	}
}
